<template>
	<div class="row h-100 align-items-center" style="flex-direction: column;align-items: center;justify-content: center;">
		<Alerta :variant="'info'" :texto="'<h5>Para prosseguir faça o procedimento a seguir!</h5>'" />
		<div id="recaptcha">
			<RecaptchaV2 @load-callback="handleLoadCallback" />
		</div>
	</div>
</template>

<script setup>
import { useRoute } from 'vue-router'
import Alerta from '@/components/Alertas/Alerta.vue'
import { RecaptchaV2 } from "vue3-recaptcha-v2";
import { useAcessoValidoStore } from '@/stores/acessoValido';

const storeAcessoValido = useAcessoValidoStore();
const route = useRoute();

function handleLoadCallback(response) {
	if (response) {
		storeAcessoValido.salvar(route.params.idAtendimento, true);
	}
}
</script>